<ng-container *ngIf="home">
  <div class="tx-home__wrapper">
    <ng-container *ngIf="home?.data?.attributes?.banners">
      <widget-banner [widget]="home.data.attributes.banners"></widget-banner>
    </ng-container>

    <ng-container
      *ngFor="
        let widget of home?.data?.attributes?.content;
        let i = index;
        let first = first;
        let last = last
      "
    >
      <ng-container
        *ngIf="widget.__component === 'microsites.display-products'"
      >
        <widget-display-products [widget]="widget"></widget-display-products>
      </ng-container>
    </ng-container>

    <div
      class="grid grid-cols-1 md:grid-cols-12 grid-flow-row gap-2 justify-center"
    >
      <ng-container
        *ngFor="
          let widget of home?.data?.attributes?.content;
          let i = index;
          let first = first;
          let last = last
        "
      >
        <ng-container [ngSwitch]="widget?.__component">
          <ng-container *ngSwitchCase="'article.article-group'">
            <div class="col-span-1 md:col-span-12">
              <widget-news
                [widget]="widget"
                [classes]="$any({ 'mb-7': last, 'mt-7': first })"
                [adsPosition]="i"
                [adsPage]="'home'"
              ></widget-news>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'article.articles-group'">
            <div class="col-span-1 md:col-span-12">
              <widget-articles-group [widget]="widget"></widget-articles-group>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'product.product-group'">
            <div class="col-span-1 md:col-span-12">
              <widget-product-group
                [widget]="widget"
                [classes]="$any({ 'mb-7': last, 'mt-7': first })"
                class="bg-gray10-500"
                [adsPosition]="i"
                [adsPage]="'home'"
              ></widget-product-group>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.banner'">
            <div class="col-span-1 md:col-span-12">
              <widget-banner [widget]="widget"></widget-banner>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.image'">
            <div [class]="getResponsiveClasses(widget)">
              <widget-image [widget]="widget"></widget-image>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.text'">
            <div [class]="getResponsiveClasses(widget)">
              <widget-text [widget]="widget"></widget-text>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.block-title'">
            <div [class]="getResponsiveClasses(widget)">
              <widget-title [widget]="widget"></widget-title>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.block-title-description'">
            <div [class]="getResponsiveClasses(widget)">
              <widget-block-title-description
                [widget]="widget"
              ></widget-block-title-description>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.editor-text'">
            <div [class]="getResponsiveClasses(widget)">
              <widgets-editor-text [widget]="widget"></widgets-editor-text>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.gallery'">
            <div class="col-span-1 md:col-span-12">
              <widget-gallery [widget]="widget"></widget-gallery>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.video'">
            <div [class]="getResponsiveClasses(widget)">
              <widget-video [widget]="widget"></widget-video>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.form'">
            <div
              class="col-span-1 md:col-span-8 md:col-start-3 lg:col-start-3 xl:col-start-3"
            >
              <widget-form [widget]="widget"></widget-form>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.section-image-title-text'">
            <widgets-image-title-text
              class="col-span-1 md:col-span-12"
              [widget]="widget"
            ></widgets-image-title-text>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.spacer'">
            <div [class]="getResponsiveClasses(widget)">
              <widget-spacer></widget-spacer>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.pai-media'">
            <div class="col-span-1 md:col-span-12">
              <widget-pai-media [widget]="widget"></widget-pai-media>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'article.block-author'">
            <div
              class="col-span-1 md:col-span-8 md:col-start-3 lg:col-start-3 xl:col-start-3"
            >
              <widget-article-block-author
                [widget]="{ config: widget }"
              ></widget-article-block-author>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'club.header-club'">
            <div class="col-span-1 md:col-span-12">
              <app-header-club [widget]="widget"></app-header-club>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'widgets.embed-code'">
            <div [class]="getResponsiveClasses(widget)">
              <widget-embed-code [widget]="widget"></widget-embed-code>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!isKnownWidget(widget) && isDev">
          <div
            class="col-span-1 md:col-span-12 text-xs text-gray-500 px-4 py-2"
          >
            Unsupported home widget: {{ widget?.__component }}
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>
